import script from "./CInputQualities.vue?vue&type=script&setup=true&lang=js"
export * from "./CInputQualities.vue?vue&type=script&setup=true&lang=js"

import "./CInputQualities.vue?vue&type=style&index=0&id=10bcc78c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10bcc78c"]])

export default __exports__